/**
 * @typedef {Object} GlobalContextValue
 * @property {Object} player
 * @property {function} setPlayer
 * @property {boolean} fullscreenMode
 * @property {function} setFullscreenMode
 * @property {EntityRepository} entityRepository
 * @property {ModuleRepository} moduleRepository
 */

import { EntityRepository } from "../repository/EntityRepository";
import {createContext} from "react";

/**
 * The global context object.
 * @type {React.Context<GlobalContextValue>}
 */
const GlobalContext = createContext({
    player: null,
    setPlayer: () => { },
    fullscreenMode: false,
    setFullscreenMode: () => { },
    entityRepository: null,
    moduleRepository: null,
    appSettings: { },
});

export { GlobalContext };
